import React from "react";


import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { setAepsSection } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";


class AEPSSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    componentWillUnmount() {
    }

    showAepsForm = (e) => {
        e.preventDefault();
        if (this.props.agentInfo.status == 'BANK_KYC_COMPLETE') {
            store.dispatch(setAepsSection('aepsForm'))
        } else {
            var gotoMerchantonboard = document.getElementById('gotoMerchantonboard');
            gotoMerchantonboard.click();
        }
    }
    merchantRegister= (e) => {
        e.preventDefault();
        if (this.props.agentInfo.status == 'BANK_KYC_COMPLETE') {
            store.dispatch(setAepsSection('merchant-register'))
        } else {
            var gotoMerchantonboard = document.getElementById('gotoMerchantonboard');
            gotoMerchantonboard.click();
        }
    }
    showAepsFormYbl = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('aepsFormYbl'))
    }



    render() {

        return (
            <div class={this.props.agentInfo.status == 'BANK_KYC_COMPLETE' ? 'col-12 col-lg-5 col-xl-4' :
                'col-12'}>
                <Link to='/merchant-onboard'>
                    <button id='gotoMerchantonboard' hidden={true}></button>
                </Link>
                {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                    <div class="card-b" id="leftdiv">
                        <div class="head">
                        <button type="button" id="aepsbtn" class="dbbtn3 float-right"
                            onClick={this.showAepsForm}>AePS</button>
                        <button type="button" id="aepsbtn" class="dbbtn3 float-right"
                                onClick={this.merchantRegister}>Merchant Regsitration</button>
                        <h3>AePS</h3>
                           
                        </div>
                        <div class='valid-success'>
                        Please connect your device before AePS
                        </div>
                       

                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        
                        <div class="downloadlink">
                            <h5>Download Driver</h5>
                            <p><a href="https://pbrdms.precisionbiometric.co.in/RDService/index.html" target="_blank">Precision</a> | <a href="https://onlinerdservice.com/morpho-rd-service" target="_blank">Morpho</a> | <a href="https://pbrdms.precisionbiometric.co.in/RDService/index.html" target="_blank">PB510</a></p>
                            <p><a href="https://rdserviceonline.com/" target="_blank">Biometric Device Registration</a> | <a href="https://rdserviceonline.com/">Download User Guide</a></p>
                        </div>
                    </div>
                }
                {this.props.agentInfo.status != 'BANK_KYC_COMPLETE' &&
                    <div class="card-b" id="rightdiv">
                        <div class="head">

                            <h3>AePS</h3>

                        </div>
                        <div class='valid-success'>
                            Please onboard before AePs
                        </div>
                        <button type="button" id="aepsbtn" class="lbbtn"
                            onClick={this.showAepsForm}>Merchant Onboard</button>

                    </div>
                }
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token }
}
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token
});




export default connect(mapStateToProps, null)(AEPSSearch);
